import type { RiskProfileAsset } from '../types/riskProfileAssets.types'
import type { QuadrantPoint } from '../types/riskProfileQuadrant.types'
import { resolveAssetLabel, resolveLabelKey } from './riskProfileAsset.utils'

export function buildQuadrantPoints(assets: RiskProfileAsset[]): QuadrantPoint[] {
  if (assets.length === 0) return []
  const labelKey = resolveLabelKey(assets[0])
  return assets.map((asset) => ({
    assetId: resolveAssetLabel(asset, labelKey),
    asset_type: asset.asset_type,
    aggregate_id: asset.aggregate_id,
    replacementCost: parseFloat(asset.replacement_cost || '0'),
    damageCost: asset.damage_cost,
  }))
}
